module.exports = __webpack_public_path__ + "static/img/14.e6d57b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/14.png
// module id = 4EPo
// module chunks = 0